import {acceptedValidateEligibility, approve} from '../../rest/candidature';
import {useParams} from 'react-router-dom';
import React from "react";
import {CandidatureValidationElegibility} from "../../components/candidature/CandidatureValidationElegibility";

export function AcceptEligibility() {
    const {externalId} = useParams();

    const acceptCandidatureHandler = async () => {
        await acceptedValidateEligibility(externalId);
    }

    return (
        <CandidatureValidationElegibility
            validationTitle='candidature.flow.validate.elegibility'
            messageConfirmation='candidature.flow.validate.elegibility.message'
            callbackHandler={acceptCandidatureHandler}
            isApprove={true}
        />
    );

}
